// html editor wrapper
(function (he) {
    he.setText = function (editorId, text) {
        var editor = iged_getById(editorId);
        editor.setText(text);
    }

    he.Helper = {
    };

    function isDesignMode() {
        return $("#WebHtmlEditor1_ts_d").css("background-color") != "transparent";
    }
    function getHtml() {
        var html = $("#WebHtmlEditor1_tw").html() || $('#WebHtmlEditor1_tw').contents().find("html").html();
        if (!window.htmlEditor.isDesignMode())
            html = HTMLHelpers.htmlDecode(html);
        return html;
    }

    he.isDesignMode = isDesignMode;
    he.getHtml = getHtml;

})(window.htmlEditor = (window.htmlEditor || {}));



// html editor helper methods
window.htmlEditorHelper = function () {
	function getJson(url, inputData, successCallback, errorCallback) {
		$.ajax({
			type: 'POST',
			url: url,
			dataType: 'json',
			data: '{ inputData: "' + inputData + '" }',
			async: false,
			contentType: 'application/json; charset=utf-8',
			success: function (retVal) {
				if (successCallback)
					successCallback(inputData, retVal.d);
			},
			error: function (xhr, status, err) {
				if (errorCallback)
					errorCallback(xhr, status, err);
			}
		});
	}

	function doAfterAction(oEditor, actID, p8) {
		// hack for other browsers - afteraction is only firing properly in IE, hence following code block
		if (!p8 || p8.closed) {
			if (actID.toString().toLowerCase() == 'fontname') {
				$('.htmlEditorContentArea font[face]').each(function () {
					var oldStyle = ($(this).attr('style') != undefined) ? $(this).attr('style') : '';
					$(this).attr('style', oldStyle + 'font-family:' + $(this).attr('face') + '; ');
				});
			}
			if (actID.toString().toLowerCase() == 'fontsize') {
				$('.htmlEditorContentArea font[size]').each(function () {
					var fontsize;
					switch ($(this).attr('size')) {
						case '1':
							fontsize = '10px';
							break;
						case '2':
							fontsize = '12px';
							break;
						case '3':
							fontsize = '16px';
							break;
						case '4':
							fontsize = '18px';
							break;
						case '5':
							fontsize = '24px';
							break;
						case '6':
							fontsize = '30px';
                            break;
						case '7':
							fontsize = '36px';
							break;
						default:
							return;
					}
					var oldStyle = ($(this).attr('style') != undefined) ? $(this).attr('style') : '';
					$(this).attr('style', oldStyle + 'font-size:' + fontsize + '; ');
				});
			}
		}
		else {
			setTimeout(function () { doAfterAction(oEditor, actID, p8); }, 1000);
		}
	}

	function WebHtmlEditor_AfterAction(oEditor, actID, oEvent, p4, p5, p6, p7, p8) {
		doAfterAction(oEditor, actID, p8);
	}

	function WebHtmlEditor_BeforeAction(oEditor, actID, oEvent, p4, p5, p6, p7, p8) {
	}

	return {
		getFileNameFromServer: function (editorId, callback) {
			getJson('RHViewStoryboard.aspx/GetUploadedFileName', editorId, callback);
		},
		// following two methods should be assigned to ClientSideEvents before and after action properties of WebHtmlEditor
		EditorAfterAction: WebHtmlEditor_AfterAction,
		EditorBeforeAction: WebHtmlEditor_BeforeAction
	};
} ();


(function (sb) {
    sb.FileHandler = {};
    var proportion;
    var fileType;
    
    function setupInsertGUI(ft) {
        fileType = ft;
        
        if(fileType == "File")
            filesGUI();
        else
            imageGUI();
        Helpers.performJSonCall("RHVIewStoryboard.aspx/GetFilesList", null, bindFiles, null, true);
    }

    function filesGUI(){
        $("#imgKeepProp, label[for='imgKeepProp']").css("display","none");
        $("#imgHeight, label[for='imgHeight']").css("display","none");
        $("#imgWidth, label[for='imgWidth']").css("display","none");
        $("#filePreview").css("display","none");
    }
    function imageGUI(){
        $("#imgKeepProp, label[for='imgKeepProp']").css("display","");
        $("#imgHeight, label[for='imgHeight']").css("display","");
        $("#imgWidth, label[for='imgWidth']").css("display","");
        $("#filePreview").css("display","");
    }

    function bindFiles(fileList) {
        $("#fileList").empty();
        if (fileList) {
            fileList.forEach(function(file) {
                if (fileType === file.FileType)
                    $("#fileList").append("<option value='" + file.URL + "' class='" + file.FileType + "'>" + HTMLHelpers.htmlEncode(file.FileName) + "</option>");
            });
        }

        $("#fileList option").first().attr("selected", true);

        fileChanged();
    }

    function previewImage(imageUrl) {
        disableInsert(true);
        $("#insertFileContainer img").attr("src", imageUrl);

        $("#filePreview img").load(function () { 
            $("#insertFileContainer img").css("width", "");
            $("#insertFileContainer img").css("height", "");
            var width = $("#insertFileContainer img").width();
            var height = $("#insertFileContainer img").height();

            $("#imgWidth").val(width);
            $("#imgHeight").val(height);

            proportion = width / height;

            disableInsert(false);
        });
    }

    function disableInsert(disabled){
        $("#insertFile").attr("disabled", disabled);
        $("#imgWidth").attr("disabled", disabled);
        $("#imgHeight").attr("disabled", disabled);
        $("#imgKeepProp").attr("disabled", disabled);
    }

    function setImageSize(sender, keepProportions){
        var height = $("#filePreview img").height();
        var width = $("#filePreview img").width();
        
        if($(sender).attr("id") == "imgWidth")
        {
            if(keepProportions)
                height = $(sender).val() / proportion;
            width = $(sender).val();
        }
        else
        {
            if(keepProportions)
                width = $(sender).val() * proportion;
            height = $(sender).val();
        }

        $("#imgHeight").val(height);
        $("#imgWidth").val(width);
        $("#filePreview img").height(height);
        $("#filePreview img").width(width);
    }

    function fileChanged() {
        var selectedFile = $("#fileList option:selected");

        $("#insertFileContainer img").removeAttr("src");
        if (selectedFile.hasClass("Image"))
        {
            $("#insertFileContainer img").css("display", "");
            previewImage(selectedFile.val());
        }
        else
            $("#insertFileContainer img").css("display", "none");
    }

    function insert() {
        var selectedFile = $("#fileList option:selected");

        var fileToInsert;
        if (selectedFile.hasClass("Image"))
        {
            var width = $("#imgWidth").val();
            var height = $("#imgHeight").val();

            fileToInsert = "<img src='" + selectedFile.val() + "' style='width:"+width+"px; height:"+height+"px'></img>";
        }
        else
            fileToInsert = "<a href='" + selectedFile.val() + "'>"+selectedFile.text()+"</a>";

        if (!window.htmlEditor.isDesignMode())
            fileToInsert = HTMLHelpers.htmlEncode(fileToInsert);

        // fix browser compatibility
        var editor = $("#WebHtmlEditor1_tw")[0];
        if ($(editor).attr('nodeName') == 'IFRAME')
            $(editor).contents().find('body').append(fileToInsert);
        else
            $(editor).append(fileToInsert);
        $("#insertFileContainer").dialog('close');
    }


    sb.FileHandler.setupInsertGUI = setupInsertGUI;
    sb.FileHandler.fileChanged = fileChanged;
    sb.FileHandler.insert = insert;
    sb.FileHandler.setImageSize = setImageSize;

})(window.Storyboard = (window.Storyboard || {}));
